import type { FC } from 'react'
import { useFormik } from 'formik'
import { useRouter } from 'next/router'
import * as Yup from 'yup'

import { Box, Button, FormHelperText, TextField } from '@mui/material'

import { useMounted } from '../../hooks/use-mounted'
import useToast from '../../hooks/use-toast'
import api from '../../utils/api'

export const ForgotPasswordForm: FC = props => {
  const isMounted = useMounted()
  const router = useRouter()

  // const { token, email } = props;

  const toast = useToast()

  const formik = useFormik({
    initialValues: {
      email: '',

      submit: null,
    },
    validationSchema: Yup.object({
      email: Yup.string().min(4).max(255).email().required(),
    }),
    onSubmit: async (values, helpers): Promise<void> => {
      try {
        await api.post('/oauth/password/forgot', {
          email: values.email,
        })

        toast.notify({
          title: 'Your password reset was received.',
          description:
            'If your email address is located we will send an email.',
        })

        helpers.resetForm()

        // window.location.href = '/';
      } catch (err) {
        console.error(err)
        if (isMounted()) {
          helpers.setStatus({ success: false })
          helpers.setErrors({ submit: 'Invalid Email' })
          helpers.setSubmitting(false)

          toast.notifyError('Invalid Email')
        }
      }
    },
  })

  return (
    <form noValidate onSubmit={formik.handleSubmit} {...props}>
      <TextField
        autoFocus
        error={Boolean(formik.touched.email && formik.errors.email)}
        fullWidth
        helperText={formik.touched.email && formik.errors.email}
        label="Email"
        margin="normal"
        name="email"
        onBlur={formik.handleBlur}
        onChange={formik.handleChange}
        type="email"
        value={formik.values.email}
      />
      {formik.errors.submit && (
        <Box sx={{ mt: 3 }}>
          <FormHelperText error>{formik.errors.submit}</FormHelperText>
        </Box>
      )}
      <Box sx={{ mt: 2 }}>
        <Button
          disabled={formik.isSubmitting}
          fullWidth
          size="large"
          type="submit"
          variant="contained"
        >
          Submit
        </Button>
      </Box>
    </form>
  )
}
